




































































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwBarProgress } from '@libs-uuif/shared/sw-progress';
import { MswWidgetCard } from '@/shared/custom-component/msw-widget-card';
import { MswProductsTabRoute } from '@/modules/msw-products';
import { State } from 'vuex-class';
import { DashBoardStoreState } from '@/modules/msw-dashboard/msw-dashboard.store';
import { RootStoreState } from '@/store';
const cssPrefix = 'msw-productmgmt-widget';

@Component({
  components: {
    MswWidgetCard,
    SwBarProgress,
    SwIcon,
  },
})
export default class MswProductmgmtWidget extends SwExtendedVue {
  cssPrefix =  cssPrefix;
  waitForResp = false;
  prodGroupStatus:any = {};

  @State((state: RootStoreState) => state.DashBoardStoreModule.widgetCustomerInfo)
  widgetCustomerInfo : {
    customersCount : DashBoardStoreState['widgetCustomerInfo']['customersCount'],
    productsCount : DashBoardStoreState['widgetCustomerInfo']['productsCount'],
  };

  routeToProductsPage() {
    window.parent.postMessage({
      redirectUrl : `/m/feature/${MswProductsTabRoute.path}`,
    },                        '*');
    this.$router.push({ path: `/m/feature/${MswProductsTabRoute.path}` });
  }

}
